
import { defineComponent, onMounted } from 'vue';
import { getOrders } from './composables/Orders';
import {
  OrderTraceDialog,
  SearchOptions,
  OrderTables,
} from './components';

export default defineComponent({
  components: {
    SearchOptions,
    OrderTables,
    OrderTraceDialog,
  },
  setup() {
    onMounted(() => {
      getOrders();
    });

    return {};
  },
});
